import * as React from 'react';
import { usePerformAction, useDataLoader } from 'react-remote-data-hooks';
import classnames from 'classnames';
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import api from '../../../../api';
import {
  NotificationSettings,
  AppNotificationSettings,
  LeadStageField,
  Entity,
  convertPascalCaseToWords,
} from '../../../../core';
import { useAppSettings } from '../../../../core/hooks/useAppSettings';
import UpdateForm from './UpdateForm';
import { useMasterData } from '../../../../core/hooks/useMasterData';

interface IQuotationSettingsProps {
  data?: NotificationSettings;
  reload?: () => void;
}

const StageToMustFieldMappingTab: React.FunctionComponent<IQuotationSettingsProps> = (
  props
) => {
  const masterData = useMasterData(api.settings);
  const appSettings = useAppSettings(api.settings);

  const [editModalOpen, setEditModalOpen] = useStateWithCallbackLazy<{
    isOpen?: boolean;
    event?: string;
    id?: string;
    entity?: Entity[];
  }>({});

  const {
    performAction: update,
    error: updateError,
    isPerforming: updating,
  } = usePerformAction(
    (id: string, data: Entity) => api.settings.updateLeadStageField(id, data),
    () => {
      setEditModalOpen({}, () => {
        props.reload?.();
      });
      masterData.loadMasterData();
    }
  );

  const { data: stages } = useDataLoader<LeadStageField[]>(() =>
    api.settings.getStageDataFields()
  );

  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col">
            <h4 className="mb-0 font-weight-semibold">
              Stage To Must Field Mapping
            </h4>
          </div>
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="d-inline-flex align-items-center">
                    Events
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {masterData?.data?.leadStages
                ?.filter(
                  (x) =>
                    x.code === 'enquiry' ||
                    x.code === 'quotation' ||
                    x.code === 'configuration' ||
                    x.code === 'booking'
                )
                ?.map((item) => {
                  return (
                    <tr
                      className={classnames({
                        'cursor-pointer': true,
                        'text-blue': editModalOpen?.id === item._id,
                      })}
                      onClick={() => {
                        setEditModalOpen({}, () => {
                          setEditModalOpen(
                            {
                              isOpen: true,
                              id: item._id,
                              entity: item.entity,
                              event: item.code,
                            },
                            () => {
                              // console.log("model closed")
                            }
                          );
                        });
                      }}
                    >
                      <td>{convertPascalCaseToWords(item.code)}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
        {editModalOpen?.isOpen && (
          <>
            <div className="text-right d-md-none">
              <i className="icon-close"></i>
            </div>
            <UpdateForm
              onSubmit={(formData) => {
                update(editModalOpen?.id!, formData);
              }}
              isSubmitting={updating}
              error={updateError?.message}
              onCancel={() =>
                setEditModalOpen({}, () => {
                  // console.log("model closed")
                })
              }
              stages={stages}
              data={editModalOpen.entity}
              event={editModalOpen.event}
            ></UpdateForm>
          </>
        )}
      </div>
    </>
  );
};

export default StageToMustFieldMappingTab;
